import { useCallback, useEffect, useRef } from "react";

// the ref covers the gap between a dispatch and the re-render that carries
// the submitting flag (enter key or double click within the same tick)
export default function useSubmitGuard(submitting) {
  const locked = useRef(false);

  useEffect(() => {
    if (!submitting) locked.current = false;
  }, [submitting]);

  return useCallback(
    (submit) => (...args) => {
      if (locked.current || submitting) return undefined;
      locked.current = true;
      try {
        return submit(...args);
      } catch (error) {
        // nothing was dispatched, so submitting will never flip back to free it
        locked.current = false;
        throw error;
      }
    },
    [submitting]
  );
}
